import React, { useState } from 'react';
import { supabase } from '../lib/supabase';
import { useToast } from '../context/ToastContext';
import { useOrganization } from '../context/OrganizationContext';

export default function CreateFirstProjectModal({ onComplete }) {
  const { currentOrganization } = useOrganization();
  const { addToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    description: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const { data: project, error: projectError } = await supabase
        .from('projects')
        .insert({
          name: formData.name,
          description: formData.description,
          organization_id: currentOrganization.id,
          created_at: new Date().toISOString()
        })
        .select()
        .single();

      if (projectError) throw projectError;

      await Promise.all([
        supabase.from('connections').insert({
          project_id: project.id,
          type: 'default',
          status: 'active',
          created_at: new Date().toISOString()
        }),
      ]);

      addToast('Project created successfully', 'success');
      onComplete?.();
    } catch (error) {
      console.error('Error creating project:', error);
      addToast(error.message, 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-dark-200 rounded-lg shadow-xl max-w-2xl w-full mx-4 p-8">
      <h2 className="text-2xl font-bold text-white mb-2 text-center">Create Your First Project</h2>
      <p className="text-gray-400 mb-8 text-center">
        Projects help you organize your content and workflows
      </p>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-1">
            Project Name*
          </label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="w-full px-3 py-2 bg-dark-300 border border-dark-400 rounded focus:outline-none focus:ring-2 focus:ring-accent-primary text-white"
            placeholder="Enter project name"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-1">
            Project Description
          </label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            rows={3}
            className="w-full px-3 py-2 bg-dark-300 border border-dark-400 rounded focus:outline-none focus:ring-2 focus:ring-accent-primary text-white"
            placeholder="Brief description of your project"
          />
        </div>

        <button
          type="submit"
          disabled={loading || !formData.name}
          className="w-full px-4 py-2 bg-accent-primary text-white rounded hover:bg-accent-primary-dark disabled:opacity-50 transition-colors"
        >
          {loading ? 'Creating Project...' : 'Create Project & Get Started'}
        </button>
      </form>
    </div>
  );
} 